export default __webpack_public_path__ + "static/media/insight.c01970e3.svg";